// extracted by mini-css-extract-plugin
module.exports = {"AskIdaButton":"AskIdaButton--2E5aX"};